import React from 'react'
import "./StudentPage.css"

const Banner = () => {
  return (
    <div className='student-page-banner'>
    </div>
  )
}

export default Banner
